// extracted by mini-css-extract-plugin
export default {"product_container":"MarketPlaceProduct_product_container__PY46+"};